// assets/js/mats-contact.js
document.addEventListener('DOMContentLoaded', () => {
  const ajaxURL = (window.MATS_CONTACT && MATS_CONTACT.ajax_url) || '/wp-admin/admin-ajax.php';

  document.querySelectorAll('form[data-ajax="1"]').forEach((form) => {
    const alertBox = document.getElementById('mats-contact-alert');
    const submitBtn = form.querySelector('button[type="submit"]');

    function showAlert(type, msg) {
      if (!alertBox) return;
      alertBox.className = `alert alert-${type}`;
      alertBox.textContent = msg;
      alertBox.classList.remove('d-none');
      alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function setLoading(on) {
      if (!submitBtn) return;
      submitBtn.disabled = on;
      if (on) {
        submitBtn.dataset._text = submitBtn.innerHTML;
        submitBtn.innerHTML = `<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Sending…`;
      } else {
        if (submitBtn.dataset._text) submitBtn.innerHTML = submitBtn.dataset._text;
        submitBtn.removeAttribute('data-_text');
      }
    }

    // Bootstrap client-side validation
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!form.checkValidity()) {
        form.classList.add('was-validated');
        return;
      }

      const data = new FormData(form);
      // Route AJAX to admin-ajax.php
      data.set('action', 'mats_contact');

      setLoading(true);
      fetch(ajaxURL, {
        method: 'POST',
        credentials: 'same-origin',
        body: data
      })
      .then(async (res) => {
        let json = {};
        try { json = await res.json(); } catch(_) {}
        if (!res.ok || !json || json.success !== true) {
          const msg = (json && json.data && json.data.message) || 'Sorry, something went wrong.';
          throw new Error(msg);
        }
        // Success
        showAlert('success', json.data.message || 'Thanks! Your message has been sent.');
        form.reset();
        form.classList.remove('was-validated');
      })
      .catch((err) => {
        showAlert('danger', err.message || 'Unable to send message. Please try again.');
      })
      .finally(() => setLoading(false));
    });
  });
});
